import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import images from "../common/images";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { formatTimeRange } from "../utils/common";
import Hero from "../components/Hero";
import FavouriteIcon from "../components/FavouriteIcon";
import Modal from 'react-modal';
import { usePost } from "../hooks/usePost";
import useLocalStorage from "../hooks/useLocalStorage";
import { toast } from "react-toastify";
import * as z from "zod";
import ImageCarousel from "../components/ImageCarousel";
import whatsappIcon from "../assets/img/whatsapp.png";
import telephoneIcon from "../assets/img/telephone.png";
import googleMapsIcon from "../assets/img/google-maps.png";
import { getEventClub } from "../utils/eventClub";
import {
  getClubPath,
  getArtistPath,
  getEventPath,
} from "../utils/clubPath";
import NotFound from "./notFound";
import LoadingSpinner from "../components/LoadingSpinner";
import useMobileStoreRedirect from "../hooks/useMobileStoreRedirect";

const EventDetails = () => {
  const navigate = useNavigate();
  const { eventId, eventSlug, city, cityOrId } = useParams();
  const resolvedEventId = eventSlug || eventId || cityOrId;
  const { data: event, isFetching, isError, isFetched, isLoading } = useQuery({
    queryKey: [`api/events/${resolvedEventId}`],
    enabled: Boolean(resolvedEventId),
    retry: false,
  });
  const eventClub = getEventClub(event?.data);

  useMobileStoreRedirect("events", event?.data?._id || resolvedEventId);

  const [carouselImages, setCarouselImages] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!event?.data) return;

    const nextPath = getEventPath(event.data, city);
    if (nextPath && window.location.pathname !== nextPath) {
      navigate(nextPath, { replace: true });
    }
  }, [event?.data, city, navigate]);

  useEffect(() => {
    if (
      event &&
      event.data &&
      eventClub &&
      eventClub.media &&
      Array.isArray(eventClub.media.ambienceImages)
    ) {
      setCarouselImages(eventClub.media.ambienceImages);
    }
  }, [event, eventClub]);

  const token = localStorage.getItem("userToken");
  const isLoggedIn = JSON.parse(token);
  const [isArtistModalOpened, setIsArtistModalOpen] = React.useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }
  function toggleArtistInfoModal() {
    setIsArtistModalOpen((prev) => !prev);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleLinkClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault();
      navigate("/signin");
    }
  };
  const openRegisterEvent = () => {
    openModal();
  };

  const carouselOptions = {
    stagePadding: 0,
    loop: true,
    dots: true,
    margin: 10,
    autoplay: true,
    nav: true,
    navText: [
      '<i class="fa fa-angle-left" aria-hidden="true"></i>',
      '<i class="fa fa-angle-right" aria-hidden="true"></i>',
    ],
    navContainer: "#slider-items .custom-nav",
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 },
    },
  };
  const [isAttendent, setIsAttendent] = useLocalStorage(
    `attendance_${event?.data?._id || resolvedEventId}`,
    false,
  );
  const [formData, setFormData] = useState({});
  const { mutate, isPending } = usePost({
    url: "/api/attend-event",
    onSuccess: (res) => {
      toast.success("Event attended successfully");
      console.log("Event attended successfully", res);
      setIsAttendent(true);
      closeModal();
    },
    onError: (error) => {
      console.error("Error attending event:", error);
    },
  });
  const handleSubmit = (submitEvent) => {
    submitEvent.preventDefault();
    const result = attendEventSchema.safeParse({
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
    });
    if (!result.success) {
      toast.error("Name, email and mobile number are required");
      return;
    }
    mutate(new FormData(submitEvent.target));
  };
  function handlFieldChange(name) {
    return (ev) => {
      setFormData((prev) => {
        return { ...prev, [name]: ev.target.value };
      });
    };
  }

  if (!resolvedEventId || isLoading || isFetching || !isFetched) {
    return (
      <Layout>
        <LoadingSpinner />
      </Layout>
    );
  }

  if (isError || !event?.data?._id) {
    return <NotFound />;
  }

  return (
    <Layout>
      <AttendEventForm {...{ modalIsOpen, afterOpenModal, closeModal, handleSubmit, eventId: event?.data?._id || resolvedEventId, formData, handlFieldChange, isPending }} />
      <Hero title="Event Details" />
      {/* Details List */}
      <section
        className="details-sec section-gap wow fadeInUp"
        data-wow-delay="0.2s"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="about-club-sec">
                <div className="details-head-sec">
                  <div className="text-sec">
                    <h3 className="title-30">{event?.data?.title}</h3>
                    <dialog className="artistsList_modal" open={isArtistModalOpened}>
                      <ol>
                        {event?.data?.artists?.map((art, artKey) => (
                          <li key={art._id}>
                            <Link to={getArtistPath(art)}>
                              <img src={art?.images?.[0]} alt={art?.name} />
                              <span>{art.name}</span>
                            </Link>
                          </li>
                        ))}
                      </ol>
                    </dialog>
                    {Array.isArray(event?.data?.artists) &&
                    event?.data?.artists?.length ? (
                      <div className="img-sec circle-img event__artist-item" onClick={toggleArtistInfoModal}>
                        <img
                          src={
                            Array.isArray(event?.data?.artists) &&
                            Array.isArray(event?.data?.artists[0]?.images) &&
                            event?.data?.artists[0]?.images?.length &&
                            event?.data?.artists[0]?.images[0]
                              ? event?.data?.artists[0]?.images[0]
                              : images?.background
                          }
                          className="img-fluid"
                          alt="img"
                        />
                        <p>
                          By{" "}
                          <strong>
                            {event?.data?.artists &&
                              event?.data?.artists[0]?.name}{" "}
                            {event?.data?.artists?.length > 1
                              ? `+${event?.data?.artists?.length - 1}`
                              : null}
                          </strong>
                        </p>
                      </div>
                    ) : null}
                  </div>
                  <div className="cnt-sec">
                    <FavouriteIcon
                      endpoint={`api/user/likes/events/${event?.data?._id}`}
                      item={event?.data}
                      isLiked={!event?.meta?.isLiked}
                      defaultColor="#000000"
                    />
                    <p className="p-20">
                      <i className="far fa-clock"></i>
                      {event?.data?.eventStartTime &&
                        ` ${moment(event?.data?.eventStartTime).format(
                          "ddd MMM DD"
                        )} at ${formatTimeRange(
                          event?.data?.eventStartTime,
                          event?.data?.eventEndTime,
                          false
                        )}`}
                    </p>
                    {event?.data?.description ? (
                      <p className="p-20" style={{ color: "#000000" }}>
                        {event?.data?.description}
                      </p>
                    ) : null}
                    <p className="p-20 text-black" style={{ color: 'black'}}>
                      <i className="fas fa-map-marked-alt"></i>{" "}
                      <un>
                        <Link
                          to={getClubPath(eventClub)}
                          style={{ color: "#000", fontWeight: 800 }}
                        >
                          <strong>{eventClub?.name}</strong>
                        </Link>
                        {", "}
                        {eventClub?.locality}
                      </un>
                      , {eventClub?.city}
                    </p>
                  </div>
                </div>
                {!isAttendent ? (
                <div className="ml-4 mt-3">
                  <button className="btn btn-dark btn-lg" type="button" onClick={openRegisterEvent}>Attend Event</button>
                </div>
                ): null}
                <div className="club-direction">
                  <div className="row no-gutters">
                    <div className="col-lg-4">
                      <div
                        className={`sec radius-left ${
                          event?.data?.club?.googleMapLink ? "active" : ""
                        }`}
                      >
                        <a
                          href={event?.data?.club?.googleMapLink}
                          onClick={handleLinkClick}
                        >
                          <img src={googleMapsIcon} alt="Google maps" className="size--icon" />
                          <h4 className="title-18">Direction</h4>
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div
                        className={`sec radius-0 ${
                          event?.data?.club?.whatsappNumber ? "active" : ""
                        }`}
                      >
                        <a
                          href={
                            "http://api.whatsapp.com/send?phone=91" +
                            event?.data?.club?.whatsappNumber +
                            `&text=Hey%20there%2C%0A%0AI%20am%20reaching%20out%20to%20enquire%20via%20the%20AZZIR%20app`
                          }
                          // onClick={handleLinkClick}
                        >
                          <img src={whatsappIcon} alt="Whatsapp" className="size--icon" />
                          <h4 className="title-18">WhatsApp</h4>
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div
                        className={`sec radius-right ${
                          event?.data?.club?.phoneNumber ? "active" : ""
                        }`}
                      >
                        <a
                          href={"tel:" + event?.data?.club?.phoneNumber}
                          onClick={handleLinkClick}
                        >
                          <img src={telephoneIcon} className="size--icon" />
                          <h4 className="title-18">Call</h4>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="details-slider-sec">
                <div id="slider-items" className="itmes-slider no-space">
                  <ImageCarousel
                    images={carouselImages.length > 0 ? carouselImages : [images.background]}
                    autoplay={true}
                    loop={true}
                  />
                  <div className="owl-theme">
                    <div className="owl-controls">
                      <div className="custom-nav owl-nav"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Details List End */}

      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>

    </Layout>
  );
};

export default EventDetails;

export const attendEventSchema = z.object({
  name: z.string().trim().min(2, { message: "Name is required" }),
  email: z.string().trim().email({ message: "Enter a valid email" }),
  phone: z
    .string()
    .trim()
    .regex(/^\d{10}$/, { message: "Enter a 10-digit mobile number" }),
});

export function AttendEventForm({modalIsOpen, afterOpenModal, closeModal, handleSubmit, eventId, formData, handlFieldChange, isPending}) {
  const parsed = attendEventSchema.safeParse({
    name: formData?.name ?? "",
    email: formData?.email ?? "",
    phone: formData?.phone ?? "",
  });
  const fieldErrors = parsed.success
    ? {}
    : parsed.error.issues.reduce((acc, issue) => {
        const key = issue.path[0];
        if (key && !acc[key]) acc[key] = issue.message;
        return acc;
      }, {});
  const isValid = parsed.success;

  const onSubmit = (submitEvent) => {
    submitEvent.preventDefault();
    if (!isValid) {
      toast.error("Name, email and mobile number are required");
      return;
    }
    handleSubmit(submitEvent);
  };

  return <Modal
    isOpen={modalIsOpen}
    onAfterOpen={afterOpenModal}
    onRequestClose={closeModal}
    className={"event-attendance-modal"}
    contentLabel="Example Modal"
  >
    <h2>Attend Event</h2>
    <button onClick={closeModal} className="modal__close-btn">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>

    </button>
    <form onSubmit={onSubmit} noValidate>
      <input type="hidden" name="eventId" value={eventId} />
      <div className="mb-3 input-sec">
        <input
          required
          value={formData.name || ""}
          onChange={handlFieldChange("name")}
          className="form-control"
          type="text"
          name="name"
          placeholder="Name *"
          autoComplete="name"
        />
        {fieldErrors.name && formData.name != null && formData.name !== "" ? (
          <p className="text-danger text-sm">{fieldErrors.name}</p>
        ) : null}
      </div>
      <div className="mb-3 input-sec">
        <input
          required
          value={formData.email || ""}
          onChange={handlFieldChange("email")}
          className="form-control"
          type="email"
          name="email"
          placeholder="Email *"
          autoComplete="email"
        />
        {fieldErrors.email && formData.email ? (
          <p className="text-danger text-sm">{fieldErrors.email}</p>
        ) : null}
      </div>
      <div className="mb-3 input-sec">
        <input
          required
          value={formData.phone || ""}
          onChange={handlFieldChange("phone")}
          className="form-control"
          type="tel"
          name="phone"
          placeholder="Mobile number *"
          autoComplete="tel"
          inputMode="numeric"
          maxLength={10}
        />
        {fieldErrors.phone && formData.phone ? (
          <p className="text-danger text-sm">{fieldErrors.phone}</p>
        ) : null}
      </div>
      <div className="mb-3 input-sec">
         <label htmlFor="">No. of People</label>
        <select className="custom-select" onChange={handlFieldChange('peopleCount')} name="peopleCount" required defaultValue="1">
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
        </select>
      </div>
      <button
        type="submit"
        disabled={isPending || !isValid}
        className={`btn btn-dark ${!isValid || isPending ? "opacity-60 cursor-not-allowed" : ""}`}
      >
        {isPending ? "Submitting..." : "Submit"}
      </button>
    </form>
  </Modal>;
}
